import { render, staticRenderFns } from "./QuestionPaperManage.vue?vue&type=template&id=20a54068&scoped=true&"
import script from "./QuestionPaperManage.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperManage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperManage.vue?vue&type=style&index=0&id=20a54068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a54068",
  null
  
)

export default component.exports